import React, { useState } from 'react';
import { FileText, Download, Search, Calendar } from 'lucide-react';

const Normatividad = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const categorias = [
    { id: 'todos', nombre: 'Todos los Documentos' },
    { id: 'manuales', nombre: 'Manuales' },
    { id: 'lineamientos', nombre: 'Lineamientos' },
    { id: 'reglas', nombre: 'Reglas de Operación' },
    { id: 'otros', nombre: 'Otros' }
  ];

  const documentos = [
    {
      id: 1,
      titulo: 'Administración de Riesgos Institucional',
      categoria: 'otros',
      descripcion: 'Marco normativo para la gestión y administración de riesgos institucionales',
      fecha: '15 de Enero, 2025',
      tamano: '2.5 MB',
      formato: 'PDF'
    },
    {
      id: 2,
      titulo: 'EPY - Estatuto de Personal de Yucatán',
      categoria: 'otros',
      descripcion: 'Estatuto que regula las relaciones laborales del personal del gobierno estatal',
      fecha: '10 de Enero, 2025',
      tamano: '3.8 MB',
      formato: 'PDF'
    },
    {
      id: 3,
      titulo: 'Manual de Procedimientos',
      categoria: 'manuales',
      descripcion: 'Procedimientos operativos estándar de la Secretaría de Economía y Trabajo',
      fecha: '5 de Enero, 2025',
      tamano: '4.2 MB',
      formato: 'PDF'
    },
    {
      id: 4,
      titulo: 'Servicio Nacional del Empleo, Yucatán',
      categoria: 'otros',
      descripcion: 'Normativa del Servicio Nacional de Empleo en el estado de Yucatán',
      fecha: '28 de Diciembre, 2024',
      tamano: '1.9 MB',
      formato: 'PDF'
    },
    {
      id: 5,
      titulo: 'Manual de Políticas',
      categoria: 'manuales',
      descripcion: 'Políticas generales y específicas para el funcionamiento de la SETY',
      fecha: '20 de Diciembre, 2024',
      tamano: '2.8 MB',
      formato: 'PDF'
    },
    {
      id: 6,
      titulo: 'Manual de Control Interno',
      categoria: 'manuales',
      descripcion: 'Sistema de control interno para garantizar la transparencia y eficiencia',
      fecha: '15 de Diciembre, 2024',
      tamano: '3.1 MB',
      formato: 'PDF'
    },
    {
      id: 7,
      titulo: 'Área Coordinadora de Archivos',
      categoria: 'otros',
      descripcion: 'Lineamientos para la organización y gestión documental',
      fecha: '10 de Diciembre, 2024',
      tamano: '1.5 MB',
      formato: 'PDF'
    },
    {
      id: 8,
      titulo: 'Lineamientos Capital de la Guayabera',
      categoria: 'lineamientos',
      descripcion: 'Lineamientos para el programa Capital de la Guayabera',
      fecha: '5 de Diciembre, 2024',
      tamano: '2.2 MB',
      formato: 'PDF'
    },
    {
      id: 9,
      titulo: 'Reglas de Operación del Programa Mujer Transformadora',
      categoria: 'reglas',
      descripcion: 'Reglas de operación para el programa de apoyo a mujeres emprendedoras',
      fecha: '1 de Diciembre, 2024',
      tamano: '3.5 MB',
      formato: 'PDF'
    }
  ];

  const filteredDocumentos = documentos.filter(doc => {
    const matchSearch = doc.titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                       doc.descripcion.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategory = selectedCategory === 'todos' || doc.categoria === selectedCategory;
    return matchSearch && matchCategory;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1920&q=80" 
            alt="Normatividad SETY"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h1 className="text-5xl font-bold text-white mb-4">Normatividad SETY</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Consulta y descarga los documentos normativos que rigen el funcionamiento de la Secretaría de Economía y Trabajo de Yucatán.
          </p>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Search and Filter Section */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-8">
          <div className="flex flex-col lg:flex-row gap-4">
            <div className="flex-grow">
              <label className="block text-sm font-medium text-gray-700 mb-2">Buscar documento</label>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Buscar por nombre o descripción..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B1538] focus:border-transparent transition-all"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Category Filters */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-3">
            {categorias.map((categoria) => (
              <button
                key={categoria.id}
                onClick={() => setSelectedCategory(categoria.id)}
                className={`px-5 py-2 rounded-lg font-medium transition-all ${
                  selectedCategory === categoria.id
                    ? 'bg-[#8B1538] text-white'
                    : 'bg-white text-gray-700 border border-gray-200 hover:border-[#8B1538] hover:text-[#8B1538]'
                }`}
              >
                {categoria.nombre}
              </button>
            ))}
          </div>
        </div>

        {/* Results */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900">
            {filteredDocumentos.length} {filteredDocumentos.length === 1 ? 'Documento' : 'Documentos'}
          </h2>
        </div>

        {/* Documents List */}
        <div className="space-y-4">
          {filteredDocumentos.map((documento) => (
            <div
              key={documento.id}
              className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-[#8B1538] transition-all duration-300"
            >
              <div className="flex flex-col lg:flex-row lg:items-center gap-4">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center">
                    <FileText className="h-8 w-8 text-white" />
                  </div>
                </div>

                <div className="flex-grow">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {documento.titulo}
                  </h3>
                  <p className="text-gray-600 mb-3">
                    {documento.descripcion}
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                    <div className="flex items-center gap-1">
                      <Calendar className="h-4 w-4" />
                      <span>{documento.fecha}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium">
                        {documento.formato}
                      </span>
                      <span className="text-gray-400">|</span>
                      <span>{documento.tamano}</span>
                    </div>
                  </div>
                </div>

                <div className="flex-shrink-0">
                  <button className="w-full lg:w-auto px-6 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium flex items-center justify-center gap-2">
                    <Download className="h-5 w-5" />
                    Descargar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredDocumentos.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Search className="h-8 w-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">No se encontraron documentos</h3>
            <p className="text-gray-600">Intenta con otros términos de búsqueda o cambia los filtros</p>
          </div>
        )}

        {/* Info Box */}
        <div className="mt-12 bg-gradient-to-br from-slate-100 to-gray-200 rounded-xl p-8 border border-gray-200">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Información Importante</h3>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2 flex-shrink-0"></span>
              <span>Todos los documentos están disponibles en formato PDF</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2 flex-shrink-0"></span>
              <span>Los documentos se actualizan periódicamente conforme a las disposiciones vigentes</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2 flex-shrink-0"></span>
              <span>Para consultas sobre interpretación o aplicación de la normatividad, contacta a nuestro departamento jurídico</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Normatividad;